import { Page, H1, H2, Lead, P, Notice } from "../../public/primitives";

// Statuts autorisés : "Actif", "Prévu / non activé", "À confirmer".
// RÈGLE : ne lister que des fournisseurs réellement confirmés par le projet ; ne pas inventer la
// localisation des données ; ne pas présenter Bird (SMS en mode simulé) ni Dolibarr (futur) comme actifs.
const STATUS_STYLE = {
  "Actif": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Prévu / non activé": "bg-slate-100 text-slate-500 border-slate-200",
  "À confirmer": "bg-amber-100 text-amber-700 border-amber-200",
};

const SUBPROCESSORS = [
  {
    name: "Microsoft 365 (SMTP)",
    purpose: "Envoi d'e-mails transactionnels (notifications, vérification, invitations)",
    data: "Adresse e-mail, contenu des notifications (jamais le secret ni la clé)",
    location: "À confirmer",
    status: "Actif",
  },
  {
    name: "Bird (SMS)",
    purpose: "Remise par SMS",
    data: "Mode simulé actuellement — aucune donnée réelle transmise",
    location: "—",
    status: "Prévu / non activé",
  },
  {
    name: "Dolibarr (facturation)",
    purpose: "Génération de factures (usage commercial futur)",
    data: "—",
    location: "À confirmer",
    status: "Prévu / non activé",
  },
  {
    name: "Hébergeur",
    purpose: "Hébergement de l'infrastructure du service",
    data: "—",
    location: "À confirmer",
    status: "À confirmer",
  },
];

export const SubprocessorsPage = () => (
  <Page testid="subprocessors-page">
    <H1>Sous-traitants</H1>
    <Lead>
      Cette page recense les prestataires confirmés, ainsi que les composants techniques dont le
      fournisseur ou certaines informations restent à finaliser avant production. Chaque ligne indique
      son statut d'activation ; aucun prestataire non confirmé n'y est présenté comme actif.
    </Lead>

    <div data-testid="subprocessors-table" className="overflow-x-auto rounded-xl border border-slate-200 bg-white my-4">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-slate-50 text-left">
            <th className="py-2.5 px-4 font-semibold text-slate-700">Fournisseur</th>
            <th className="py-2.5 px-4 font-semibold text-slate-700">Finalité</th>
            <th className="py-2.5 px-4 font-semibold text-slate-700">Données</th>
            <th className="py-2.5 px-4 font-semibold text-slate-700">Localisation</th>
            <th className="py-2.5 px-4 font-semibold text-slate-700">Statut</th>
          </tr>
        </thead>
        <tbody>
          {SUBPROCESSORS.map((s) => (
            <tr key={s.name} className="border-t border-slate-100 align-top">
              <td className="py-2.5 px-4 text-slate-800 font-medium">{s.name}</td>
              <td className="py-2.5 px-4 text-slate-600">{s.purpose}</td>
              <td className="py-2.5 px-4 text-slate-600">{s.data}</td>
              <td className="py-2.5 px-4 text-slate-600">{s.location}</td>
              <td className="py-2.5 px-4">
                <span className={`inline-block rounded-full border px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLE[s.status]}`}>
                  {s.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <P className="text-slate-500">
      « Actif » : prestataire en production. « Prévu / non activé » : intégration préparée mais non
      utilisée. « À confirmer » : information non encore arrêtée.
    </P>

    <Notice testid="subprocessors-note">
      La localisation des données n'est pas inventée : elle sera précisée une fois l'hébergeur et les
      prestataires définitivement confirmés.
    </Notice>

    <H2 id="services-externes">Services externes appelés volontairement</H2>
    <P>
      Certaines fonctionnalités déclenchées explicitement par l'utilisateur effectuent une requête vers
      un service externe. Ces services ne sont pas des sous-traitants de traitement au sens habituel :
      ils sont appelés à la demande, sans transmission du contenu sensible.
    </P>
    <div data-testid="external-services-table" className="overflow-x-auto rounded-xl border border-slate-200 bg-white my-4">
      <table className="w-full text-sm">
        <tbody>
          <tr className="border-b border-slate-100"><td className="py-2.5 px-4 font-medium text-slate-800 w-1/3">Service</td><td className="py-2.5 px-4 text-slate-600">Have I Been Pwned — Pwned Passwords</td></tr>
          <tr className="border-b border-slate-100"><td className="py-2.5 px-4 font-medium text-slate-800">Finalité</td><td className="py-2.5 px-4 text-slate-600">Vérification de mots de passe compromis</td></tr>
          <tr className="border-b border-slate-100"><td className="py-2.5 px-4 font-medium text-slate-800">Déclenchement</td><td className="py-2.5 px-4 text-slate-600">Uniquement après action explicite de l'utilisateur</td></tr>
          <tr className="border-b border-slate-100"><td className="py-2.5 px-4 font-medium text-slate-800">Données applicatives transmises</td><td className="py-2.5 px-4 text-slate-600">5 premiers caractères de l'empreinte SHA-1</td></tr>
          <tr className="border-b border-slate-100"><td className="py-2.5 px-4 font-medium text-slate-800">Mot de passe</td><td className="py-2.5 px-4 text-slate-600">Jamais transmis</td></tr>
          <tr className="border-b border-slate-100"><td className="py-2.5 px-4 font-medium text-slate-800">Empreinte complète</td><td className="py-2.5 px-4 text-slate-600">Jamais transmise</td></tr>
          <tr><td className="py-2.5 px-4 font-medium text-slate-800">Données réseau</td><td className="py-2.5 px-4 text-slate-600">Données habituelles liées à une requête Internet, notamment l'adresse IP publique</td></tr>
        </tbody>
      </table>
    </div>
  </Page>
);

export default SubprocessorsPage;
